import { LOCALE } from '@wix/wix-chatbot-common/locale';

import { experiments } from '../../experiments';
import { renderModel } from '../../util/renderModel';

export const CARA_FULLPAGE_ANCHOR_DATA_HOOK = 'cara-fullpage-anchor';
export const CARA_FULLPAGE_HOST_ATTRIBUTE = 'data-cara-fullpage-host';

export const isFullPageCaraEnabled = (): boolean =>
  renderModel.isFullWidth() &&
  !renderModel.isWidget() &&
  !renderModel.isCopilot() &&
  !renderModel.isMobile() &&
  renderModel.getLocale() === LOCALE.EN &&
  experiments.is('caraInChatbotFullpage', 'B');
